/**
 * Avatar id may be equal to one of those values which
 * means that we should not fetch avatar url but
 * instead use some static avatar image.
 *
 * @type Array
 */
export default {
  avatar_boy_1:  require('@/assets/images/avatars/boy_1.svg'),
  avatar_boy_2:  require('@/assets/images/avatars/boy_2.svg'),
  avatar_boy_3:  require('@/assets/images/avatars/boy_3.svg'),
  avatar_girl_1: require('@/assets/images/avatars/girl_1.svg'),
  avatar_girl_2: require('@/assets/images/avatars/girl_2.svg'),
  avatar_girl_3: require('@/assets/images/avatars/girl_3.svg'),
  deleted_user:  require('@/assets/images/avatars/deleted_user.svg'),
}
